export const POLICY_CONSENT_KEY = 'at.ug.policy-consent';

export const hasPolicyConsent = () => {
    try {
        return localStorage.getItem(POLICY_CONSENT_KEY) === 'accepted';
    } catch {
        return false;
    }
};
